<template>
  <div class="latestAnalysisGeo tw-flex bg-white rounded-[4px] p-[10px] items-center">
    <slot></slot>
    <div class="tw-flex text-[#000] gap-2 justify-end pr-2">
      <svg id="Grupo_23959" data-name="Grupo 23959" xmlns="http://www.w3.org/2000/svg" width="17.546" height="17.546" viewBox="0 0 17.546 17.546">
        <path id="Trazado_18195" data-name="Trazado 18195" d="M12.837,14.771,12.423,16.2c-.418,1.439-.627,2.158-.949,2.34a.909.909,0,0,1-.9,0c-.322-.182-.531-.9-.949-2.34l-.414-1.425h0a3.9,3.9,0,0,0-.387-1.045,1.774,1.774,0,0,0-.5-.5,3.9,3.9,0,0,0-1.045-.387h0l-1.425-.414c-1.439-.418-2.158-.627-2.34-.949a.909.909,0,0,1,0-.9c.182-.322.9-.531,2.34-.949l1.425-.414h0a3.9,3.9,0,0,0,1.045-.387,1.774,1.774,0,0,0,.5-.5,3.9,3.9,0,0,0,.387-1.045h0L9.63,5.858c.418-1.439.627-2.158.949-2.34a.909.909,0,0,1,.9,0c.322.182.531.9.949,2.34l.414,1.425h0a3.9,3.9,0,0,0,.387,1.045,1.774,1.774,0,0,0,.5.5,3.9,3.9,0,0,0,1.045.387h0L16.2,9.63c1.439.418,2.158.627,2.34.949a.909.909,0,0,1,0,.9c-.182.322-.9.531-2.34.949l-1.425.414h0a3.9,3.9,0,0,0-1.045.387,1.774,1.774,0,0,0-.5.5,3.9,3.9,0,0,0-.387,1.045Z" transform="translate(-2.253 -2.253)" fill="#8367df"/>
        <path id="Trazado_18196" data-name="Trazado 18196" d="M5.048,5.515,4.683,6.627a.244.244,0,0,1-.463,0L3.854,5.515a.732.732,0,0,0-.467-.467L2.275,4.683a.244.244,0,0,1,0-.463l1.112-.365a.732.732,0,0,0,.467-.467l.365-1.112a.244.244,0,0,1,.463,0l.365,1.112a.732.732,0,0,0,.467.467l1.112.365a.244.244,0,0,1,0,.463l-1.112.365A.732.732,0,0,0,5.048,5.515Z" transform="translate(-2.107 -2.107)" fill="#8367df"/>
        <path id="Trazado_18197" data-name="Trazado 18197" d="M19.548,20.015l-.365,1.112a.244.244,0,0,1-.463,0l-.365-1.112a.732.732,0,0,0-.467-.467l-1.112-.365a.244.244,0,0,1,0-.463l1.112-.365a.732.732,0,0,0,.467-.467l.365-1.112a.244.244,0,0,1,.463,0l.365,1.112a.732.732,0,0,0,.467.467l1.112.365a.244.244,0,0,1,0,.463l-1.112.365A.732.732,0,0,0,19.548,20.015Z" transform="translate(-3.748 -3.748)" fill="#8367df"/>
      </svg>

      <span class="date">{{ $gettext("Latest analysis") }} {{ $moment(dateLatestAnalysis).format('DD/MM/YYYY') }}</span>
    </div>
  </div>
</template>
<script>
export default {
 props: {
   data: {
     default: null
   }
 },
  computed: {
   dateLatestAnalysis () {
     if (this.data && this.data.created_at) {
       return this.data.created_at
     }
     return null
   }
  }
}
</script>
<style scoped>
.latestAnalysisGeo{
  padding: 20px;
  margin: 0 -20px 0 -25px;
  .date{
    font-size: 14px;
  }
}
</style>
